
import React from "react";
import { Button } from "@/components/ui/button";
import { Minimize, Maximize, RotateCcw } from "lucide-react";

interface ChatHeaderProps {
  isMinimized: boolean;
  toggleMinimize: (e: React.MouseEvent) => void;
  resetChat: (e: React.MouseEvent) => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  isMinimized,
  toggleMinimize,
  resetChat,
}) => {
  return (
    <div className="bg-purple-600 dark:bg-gray-800 text-white p-3 flex justify-between items-center">
      <div className="font-semibold">Estimator Assistant</div>
      <div className="flex items-center space-x-2">
        <Button 
          variant="ghost" 
          size="icon" 
          className="w-6 h-6 text-white hover:bg-purple-700 dark:hover:bg-gray-700 rounded-full p-0"
          onClick={resetChat}
        >
          <RotateCcw size={14} />
        </Button>
        <Button 
          variant="ghost" 
          size="icon" 
          className="w-6 h-6 text-white hover:bg-purple-700 dark:hover:bg-gray-700 rounded-full p-0"
          onClick={toggleMinimize}
        >
          {isMinimized ? <Maximize size={14} /> : <Minimize size={14} />}
        </Button>
      </div>
    </div>
  );
};

export default ChatHeader;
